import routes from './routes/chat.routes';
import ModuleBase from '../../classes/ModuleBase';

export default new ModuleBase({
    name: 'Chat',
    routes: {
        requiresAuth: routes.requiresAuth
    }
});